import type { AcquisitionChannel } from '../core/types/insights'

/** Zo staan de keuzes bij "Hoe kwam je bij ons?" (shop, kassa) en in Inzicht. */
export const acquisitionLabels: Record<AcquisitionChannel, string> = {
  instagram: 'Instagram',
  google: 'Google',
  maps: 'Google Maps',
  'via-iemand': 'Via iemand',
  nieuwsbrief: 'Nieuwsbrief',
  langsgelopen: 'Langsgelopen',
  anders: 'Anders',
}

export const acquisitionQuestion = 'Hoe kwam je bij ons?'
